import {
  AddOutlined,
  RemoveOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Button, IconButton, Stack } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useHistory } from "react-router-dom";
import "./Cart.css";

export const generateCartItemsFrom = (cartData, productsData) => {
  const productMap = new Map(productsData.map(product => [product["_id"], product]));

  const cartItems = cartData.map(cartItem => {
    const product = productMap.get(cartItem['productId']);
    if (product) {
      return { ...product, quantity: cartItem.qty };
    }
    return null;
  });

  // Filter out any null items that couldn't be matched
  return cartItems.filter(item => item !== null);
};

export const getTotalCartValue = (items = []) => {
  // Calculate the total value of items in the cart
  return items.reduce((total, item) => total + item.quantity * item.cost, 0);
};

export const getTotalItems = (items = []) => {
  // Calculate the total quantity of items in the cart
  return items.reduce((totalQty, item) => totalQty + item.quantity, 0);
};

const ItemQuantity = ({ value, handleAdd, handleDelete, productId }) => {
  return (
    <Stack direction="row" alignItems="center">
      <IconButton size="small" color="primary" onClick={() => handleDelete(productId, '-')}>
        <RemoveOutlined />
      </IconButton>
      <Box padding="0.5rem" data-testid="item-qty">
        {value}
      </Box>
      <IconButton size="small" color="primary" onClick={() => handleAdd(productId, "handleAdd")}>
        <AddOutlined />
      </IconButton>
    </Stack>
  );
};

function DisplayCartItems(props) {
  const { image, name, cost, quantity, "_id": id } = props.items;

  return (
    <Box display="flex" alignItems="flex-start" padding="1rem">
      <Box className="image-container">
        <img
          src={image}
          alt={name}
          width="100%"
          height="100%"
        />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="6rem"
        paddingX="1rem"
      >
        <div>{name}</div>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          {
            !props.isReadOnly ? (
              <ItemQuantity
                value={quantity}
                handleAdd={props.buttonClick}
                handleDelete={props.buttonClick}
                productId={id}
              />
            ) : (
              <Box>
                Qty: {quantity}
              </Box>
            )
          }
          <Box padding="0.5rem" fontWeight="700">
            ${cost}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const Cart = ({ products, items = [], handleQuantity, isReadOnly }) => {
  const history = useHistory();

  if (!items.length) {
    return (
      // Display an empty cart message when there are no items
      <Box className="cart empty">
        <ShoppingCartOutlined className="empty-cart-icon" />
        <Box color="#aaa" textAlign="center">
          Cart is empty. Add more items to the cart to checkout.
        </Box>
      </Box>
    );
  }

  return (
    <>
      <Box className="cart">
        {
          // Map through the cart items and display each item
          items.map((values) => (
            isReadOnly ? (
              <DisplayCartItems isReadOnly items={values} buttonClick={handleQuantity} key={values['_id']} />
            ) : (
              <DisplayCartItems items={values} buttonClick={handleQuantity} key={values['_id']} />
            )
          ))
        }

        <Box
          padding="1rem"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Box color="#3C3C3C" alignSelf="center">
            Order total
          </Box>
          <Box
            color="#3C3C3C"
            fontWeight="700"
            fontSize="1.5rem"
            alignSelf="center"
            data-testid="cart-total"
          >
            ${getTotalCartValue(items)}
          </Box>
        </Box>

        <Box display="flex" justifyContent="flex-end" className="cart-footer">
          {window.location.pathname !== "/checkout" && (
            <Button
              color="primary"
              variant="contained"
              onClick={() => history.push("/checkout")}
              className="checkout-btn"
            >
              Checkout
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Cart;
